import React, { Component } from 'react'
import PropTypes from 'prop-types'

import { Offcanvas, CloseButton, Container, Form, InputGroup, Button, Card, Spinner } from 'react-bootstrap'

import styles from './../blocks.module.sass'

export default class Main extends Component {

  sendForm = ( e ) => {
    e.preventDefault()
    this.props.changeTopSearch( true )
  }

  render() {

    const { search, changeSearch, top_search, changeTopSearch, loading, result } = this.props

    return (
      <Offcanvas className={styles.top_search} show={top_search} onHide={() => changeTopSearch()} placement={`top`}>
        <Offcanvas.Body className={styles.top_search_body}>
          <Container>
            <div className='d-flex align-items-center justify-content-between'>
              <Form style={{ flex: `none` }} className='d-lg-none me-4' onSubmit={( e ) => this.sendForm( e )}>
                <InputGroup className={styles.catalogng_tab_search}>
                  <Form.Control
                    placeholder="Поиск"
                    aria-label="Поиск"
                    aria-describedby="basic-catalogng_tab-search"
                    className={styles.catalogng_tab_search_input}
                    value={search}
                    onChange={(e) => changeSearch( e.target.value )}
                  />
                  <Button type="submit" variant="light" id="button-catalogng_tab-search" className={styles.catalogng_tab_search_button}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 9L13 13M5.66667 10.3333C3.08934 10.3333 1 8.244 1 5.66667C1 3.08934 3.08934 1 5.66667 1C8.244 1 10.3333 3.08934 10.3333 5.66667C10.3333 8.244 8.244 10.3333 5.66667 10.3333Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </Button>
                </InputGroup>
              </Form>
              <CloseButton onClick={() => changeTopSearch()} />
              <Form className='d-none d-lg-flex' style={{ flex: `none` }} onSubmit={( e ) => this.sendForm( e )}>
                <InputGroup className={styles.catalogng_tab_search}>
                  <Form.Control
                    placeholder="Поиск"
                    aria-label="Поиск"
                    aria-describedby="basic-catalogng_tab-search"
                    className={styles.catalogng_tab_search_input}
                    value={search}
                    onChange={(e) => changeSearch( e.target.value )}
                  />
                  <Button type="submit" variant="light" id="button-catalogng_tab-search" className={styles.catalogng_tab_search_button}>
                    <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
                      <path d="M9 9L13 13M5.66667 10.3333C3.08934 10.3333 1 8.244 1 5.66667C1 3.08934 3.08934 1 5.66667 1C8.244 1 10.3333 3.08934 10.3333 5.66667C10.3333 8.244 8.244 10.3333 5.66667 10.3333Z" stroke="black" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </Button>
                </InputGroup>
              </Form>
            </div>
          </Container>
          <div className={styles.top_search_sep}></div>
          <Container>
            {loading ?
              <div className={styles.search_catalog + ` align-items-center justify-content-center`}>
                <Spinner animation="grow" variant="dark" />
              </div>
            :
              <>
                {result == null ?
                  <div className={styles.search_catalog + ` align-items-center justify-content-center`}>
                    <div>Поиск товаров</div>
                  </div>
                :
                  <>
                    {result.count == 0 ?
                      <div className={styles.search_catalog + ` align-items-center justify-content-center`}>
                        <div>По запросу «{search}» товаров не найдено, попробуйте написать по другому</div>
                      </div>
                    :
                      <div className={styles.search_catalog}>
                        {result.products.map(( product, i ) => {
                          return (
                            <Card key={i} className={styles.search_catalog_card}>
                              <Card.Img className={styles.search_catalog_card_image} variant="top" src={product.image} alt={product.name} width="196" height="274" />
                              <Card.Body className={styles.search_catalog_card_content}>
                                <div className={styles.search_catalog_card_art}>Арт. {product.article}</div>
                                <a href={product.url} className={styles.search_catalog_card_name + ` stretched-link`}>{product.name}</a>
                              </Card.Body>
                            </Card>
                          )
                        })}
                      </div>
                    }
                  </>
                }
              </>
            }
          </Container>
        </Offcanvas.Body>
      </Offcanvas>
    )
  }
}

Main.propTypes = {
  search: PropTypes.string,
  changeSearch: PropTypes.func,
  top_search: PropTypes.bool,
  changeTopSearch: PropTypes.func,
  loading: PropTypes.bool,
  result: PropTypes.array
}